import { BrowserRouter, Routes, Route } from "react-router-dom";
import PublicCv from "./pages/PublicCv";
import Login from "./pages/Login";
import Admin from "./pages/Admin";
import CvPage from "./components/cv/CvPage";
import ProtectedRoute from "./routes/ProtectedRoute";

export default function AppRouter() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<PublicCv />} />
        <Route path="/cv" element={<CvPage />} />
        <Route path="/login" element={<Login />} />
        <Route path="/admin" element={<ProtectedRoute><Admin /></ProtectedRoute>} />
      </Routes>
    </BrowserRouter>
  );
}
